
export default {
  name: 'LienTelechargement',
  props: {
    texte: {
      type: String,
      default: 'Télécharger le document (pdf)'
    },
    couleur: {
      type: String,
      default: 'bleu-marine'
    },
    idRessource: {
      type: String,
      required: true
    }
  },
  computed: {
    style () {
      const bordure = 'bordure--' + this.couleur
      const texte = 'texte--' + this.couleur
      let fond = 'fond--'

      fond += this.couleur === 'bleu-marine' ? 'marine-leger' : 'orange-leger'

      return [bordure, fond, texte]
    }
  },
  methods: {
    telechargerFichier: function (idFichier) {
      // On ajoute le timestamp au lien de téléchargement du fichier pour contourner la cache du navigateur
      const timestamp = Date.now()
      const urlFichier = `/directus/assets/${idFichier}?download&t=${timestamp}`
      window.open(urlFichier)
    }
  }
}
